import * as React from "react";
import { useState, useCallback, useMemo, useRef, useEffect } from "react";
import ExpandedEntitiesSectionsContext from "./ExpandedSectionsContext";
const collapseRow = (cur, entityId) => Object.fromEntries(Object.entries(cur != null ? cur : {}).filter(([id]) => id !== entityId));
const ExpandedSectionsProvider = ({
  children = void 0,
  getDefaultSection = void 0
}) => {
  const [expandedSections, setExpandedSections] = useState();
  const getDefaultSectionRef = useRef(getDefaultSection);
  useEffect(() => {
    getDefaultSectionRef.current = getDefaultSection;
  }, [getDefaultSection]);
  const toggleSection = useCallback((entityId, sectionName) => {
    var _a;
    const section = sectionName != null ? sectionName : (_a = getDefaultSectionRef.current) == null ? void 0 : _a.call(getDefaultSectionRef, entityId);
    setExpandedSections((cur) => {
      var _a2;
      const isShown = sectionName ? (_a2 = cur == null ? void 0 : cur[entityId]) == null ? void 0 : _a2.includes(sectionName) : !!(cur == null ? void 0 : cur[entityId]);
      return isShown || !section ? collapseRow(cur, entityId) : { ...cur != null ? cur : {}, [entityId]: [section] };
    });
  }, []);
  const contextValue = useMemo(
    () => ({
      expandedSections,
      toggleSection
    }),
    [expandedSections, toggleSection]
  );
  return /* @__PURE__ */ React.createElement(ExpandedEntitiesSectionsContext.Provider, { value: contextValue }, children);
};
export default ExpandedSectionsProvider;
